export default __webpack_public_path__ + "static/media/mobile_2.b36479cc.png";